import React from 'react';
import { Switch } from 'antd';
import { useTheme } from 'contexts/theme';

export default function ThemeSwitch() {
  const { dark, setLightTheme, setDarkTheme } = useTheme();
  function handleThemeChange(value: any) {
    value ? setDarkTheme() : setLightTheme();
  }
  return (
    <Switch
      checkedChildren="Dark"
      unCheckedChildren="Light"
      defaultChecked={dark}
      onChange={handleThemeChange}
    />
  );
}
